import { Divider, FormControl, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOptions, setChartOrientation } from '../reducers/optionsSlice';


const useStyles = makeStyles(theme => ({
  chartOptionsHorizontal: {
    position: 'relative', 
    zIndex: 69, 
    overflow: 'hidden',
    // width: '100%', 
    backgroundColor: 'transparent',
    display: 'flex',
    flexWrap: 'wrap'
    // padding: 10,
    // margin: 10,
  },
}));

export const EconomicsChartOptions = ({ darkMode, cashflowType, setCashflowType }) => {
  const classes = useStyles();

  const options = useSelector(selectOptions);

  const dispatch = useDispatch();

  
  const handleCashflowTypeChange = (event, newType) => {
    newType && setCashflowType(newType);
  };
  const handleChartOrientationChange = (event, newOrientation) => {
    newOrientation && dispatch(setChartOrientation(newOrientation));
  };

  return (
    <div className={classes.chartOptionsHorizontal}>

      

      {/* <div style={{height: 35, borderRight: '1px solid lightgrey'}}></div> */}
      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          OUTPUT TYPE
        </Typography>
        <ToggleButtonGroup
          value={cashflowType}
          exclusive
          onChange={handleCashflowTypeChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'net'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Net
            </Typography>
          </ToggleButton>
          <ToggleButton value={'gross'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Gross
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART LAYOUT
        </Typography>
        <ToggleButtonGroup
          value={options.chartOrientation}
          exclusive
          onChange={handleChartOrientationChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Horizontal'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Horizontal
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Vertical'} size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Vertical
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      {/* <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          LEGEND
        </Typography>
        <ToggleButtonGroup
          value={options.showLegend}
          exclusive
          onChange={handleShowLegendChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Show'} size="small" color="primary" style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Hide'} size="small" color="primary" style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl> */}
      <Divider style={{marginTop: 10}} />
    </div>
  );
};
